import React from 'react';

import styled from 'styled-components';



const Headline = ({ block, ...props }) => {

  return (
    <Container>
      <h3>{block.text}</h3>
    </Container>
  )
};


export default Headline;

const Container = styled.section`
  max-width: ${({ theme }) => theme.content.CONTENT_WIDTH};
  width: 90%;
  margin: 1.5em 0;
  h3 {
    font-size: 3em;
    text-align: center;
    color: ${({ theme }) => theme.colors.Primary};
    letter-spacing: 1px;
  }
  @media all and (min-width: 800px) {
    margin: 2em 0;
    h3 {
      text-align: left;
      font-size: 3.4em;
    }
  }
`;
